<template>
    <div class="containerr">
        <div class="hero nunito">
            <div class="flex-1 heroLeft">
                <div class="heroDesc">
                    <span>
                        Fast Food
                    </span>
                    <img class="w-6" src="../assets/delivery.png" alt="">
                </div>
                <h1 class="heroTitle">Planning your <span>Nutrition</span></h1>
                <span class="hero-subTitle">Fresh and testy food, Plan healthy meals for your nutrition now!</span>
                <router-link to="/foods">Let's go!</router-link>
            </div>
            <div class="flex-1 heroRight">
                <img src="../assets/salat.png" alt="">
            </div>
        </div>
    </div>
</template>